const tailwindSpacing = require('./tailwind_custom/tailwind-spacing');

module.exports = {
  content: [
    'scripts/**/*.js',
    '**/*.liquid',
  ],
  theme: {
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      white: '#F3F3F0',
      black: '#222222',
      cream: '#f0ebe6',
      grey: '#e8e8e8',
      'green-light': '#636a52',
      'green-dark': '#404534',
      blue: '#3F5561',
      'sale-red': '#CA0000'
    },
    fontWeight: {
      normal: 'normal',
      medium: '500'
    },
    fontSize: {
      'xxs': `${8/16}rem`,
      'xs': `${10/16}rem`,
      'sm': `${11/16}rem`,
      'md': `${12/16}rem`,
      'lg': `${14/16}rem`,
      'xl': `${16/16}rem`,
      'heading-xs': `${24/16}rem`,
      'heading-sm': `${32/16}rem`,
      'heading-md': `${40/16}rem`,
      'heading-lg': `${48/16}rem`,
      'heading-xl': `${60/16}rem`,
    },
    lineHeight: {
      normal: 1.8,
      tight: 1.3
    },
    letterSpacing: {
      normal: '0.025em',
      loose: '0.03em',
      wide: '0.1em'
    },
    fontFamily: {
      sans: "'Avenir Next Regular', 'Avenir', 'Gill Sans', sans-serif",
      display: "'Orelo Standard', serif",
    },
    opacity: {
      '0': '0',
      '15': '.15',
      '25': '.25',
      '50': '.5',
      '85': '.85',
      '100': '1',
    },
    extend: {
      inset: tailwindSpacing,
      gap: tailwindSpacing,
      spacing: tailwindSpacing,
      screens: {
        'xs-down': {'max' : '639px'},
        'sm-down': {'max': '767px'},
        'md-down': {'max': '1023px'},
        'hoverable': {'raw': '(hover: hover)'},
        'xxl': '1440px'
      },
      minHeight: {
        '25vw': '25vw',
      },
      maxHeight: {
        '0': '0'
      }
    }
  },
  corePlugins: {
    textTransform: false,
  }
}
